import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setSelectedWhatsAppObservations, setWhatsAppObservationsPopup } from '../../actions/index';
import CloseIcon from '@material-ui/icons/Close';
import { _ } from '../../functions/translator';
import WhatsAppObservationsList from './whatsappObservationsList';
import ExportWhatsAppButton from './ExportWhatsAppButton';

class PopUpWhatsAppObservations extends React.Component {

  constructor(props) {
      super(props)
      this.state = {
          animationTime: 900,
          submenuOpen: null,
          isSmallScreen: window.innerWidth < 1315
      }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateScreenSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateScreenSize);
  }

  updateScreenSize = () => {
    this.setState({ isSmallScreen: window.innerWidth < 1315 });
  };

  handleClosePopup = () => {
    if (this.props.popup !== 'none') {
      // Handle other popups if needed
    } else if (this.props.whatsappObservationsPopup.expanded) {
      this.props.setWhatsAppObservationsPopup({ show: true, expanded: false });
    } else {
      this.props.setWhatsAppObservationsPopup({ show: false, close: false, closeList: false, expanded: false, opacity: 1 });
      this.props.setSelectedWhatsAppObservations([]);
    }
  };

  handleAnimationClosePopup = () => {
    this.background.classList.remove('circle-background-animation');
    this.props.setWhatsAppObservationsPopup({ close: true, closeList: true, opacity: 1 });
    setTimeout(() => this.handleClosePopup(), this.state.animationTime);
  };

  componentDidUpdate(prevProps) {
    if (prevProps.whatsappObservationsPopup.show !== this.props.whatsappObservationsPopup.show) {
      this.setState({ submenuOpen: null });
    }
    if (this.props.whatsappObservationsPopup.close) return;
    if (this.background && !this.background.classList.contains('circle-background-animation')) {
      this.background.classList.add('circle-background-animation');
    }
  }

  render() {
    
    if (!this.props.whatsappObservationsPopup.show || 
        !this.props.selectedWhatsAppObservations || 
        this.props.selectedWhatsAppObservations.length === 0) {
      return null;
    }

    const selectedObservations = this.props.selectedWhatsAppObservations
      .map(id => {
        const obsData = this.props.whatsappObservations.observations[id];
        if (!obsData) return undefined;
        return { id: id, ...obsData };
      })
      .filter(obs => obs !== undefined);

    if (selectedObservations.length === 0) return null;

    const title = selectedObservations.length > 1 
      ? _('observaciones de WhatsApp seleccionadas') 
      : _('observación de WhatsApp seleccionada');

    const buttons = [
      <ExportWhatsAppButton fileType="excel" />,
      <ExportWhatsAppButton fileType="pdf" />
    ];

    return (
      <div className='popup-menu-layout whatsapp-observations-popup'>
        <div className="circle-background" ref={ref => this.background = ref} onClick={this.handleClosePopup} />

        {!this.props.whatsappObservationsPopup.expanded && (
          <h3 className='popup-menu-title'>
            {selectedObservations.length + ' ' + title}
          </h3>
        )}

        <div className='popup-menu-container mt-3'>
          <WhatsAppObservationsList observations={selectedObservations} />
          {!this.props.whatsappObservationsPopup.expanded && (
            <div className="whatsapp-observations-popup-menu-buttons-container">
              {buttons.map((btn, i) => <div key={i}>{btn}</div>)}
            </div>
          )}
        </div>

        <CloseIcon className='popup-menu-close float-right cursor-pointer' onClick={this.handleClosePopup} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  whatsappObservations: state.whatsappObservations,
  whatsappObservationsPopup: state.whatsappObservations.popup,
  selectedWhatsAppObservations: state.whatsappObservations.selectedObservations,
  popup: state.popup,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  setSelectedWhatsAppObservations,
  setWhatsAppObservationsPopup
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PopUpWhatsAppObservations);

